import { render, staticRenderFns } from "./CardTicketEdit.vue?vue&type=template&id=2f3e1676"
import script from "./CardTicketEdit.vue?vue&type=script&lang=js"
export * from "./CardTicketEdit.vue?vue&type=script&lang=js"
import style0 from "./CardTicketEdit.vue?vue&type=style&index=0&id=2f3e1676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports